import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { socialMediaProfiles as socialMediaProfilesPropTypes } from 'lib/CustomPropTypes';
import { attribution } from 'lib/social';
import $t from 'lib/trackingService';

const mapStateToProps = ({ shared }) => ({
  socialMediaProfiles: shared.socialMediaProfiles,
});

class SocialShare extends React.Component {
  static propTypes = {
    eventName: PropTypes.string.isRequired,
    headline: PropTypes.string.isRequired,
    socialMediaProfiles: socialMediaProfilesPropTypes.isRequired,
    url: PropTypes.string.isRequired,
  };

  componentDidMount() {
    const { eventName } = this.props;
    $t('register', eventName);
  }

  track = (platform) => {
    const { eventName } = this.props;
    $t('track', eventName, { platform });
  }

  render() {
    const {
      headline,
      socialMediaProfiles,
      url,
    } = this.props;

    const shareAttrib = attribution(socialMediaProfiles);

    return (
      <>
        <a
          href={`https://www.facebook.com/sharer/sharer.php?u=${url}`}
          onClick={() => { this.track('facebook'); }}
          rel="noopener noreferrer"
          target="_blank"
        >
          <span className="icon icon-facebook" />
        </a>
        <a
          href={`https://twitter.com/intent/tweet?text=${headline}&via=${shareAttrib}&url=${url}&original_referer=${url}`}
          onClick={() => { this.track('twitter'); }}
          rel="noopener noreferrer"
          target="_blank"
        >
          <span className="icon icon-twitter" />
        </a>
        <a
          href={`mailto:?subject=${headline}&body=${url}`}
          onClick={() => { this.track('email'); }}
          rel="noopener noreferrer"
          target="_blank"
        >
          <span className="icon icon-email" />
        </a>
      </>
    );
  }
}

export default connect(mapStateToProps)(SocialShare);
